<template lang="pug">
div
  BriqButton(@click="$emit('cancel')" variant="text") Cancel
  BriqSubmitButton(:data-test-id="dataTestId" @click="$emit('save')" :pending="isSaving") Save booking
  BriqButton(@click="$emit('edit')" variant="secondary" v-if="canEditSchedule" data-test-id="edit-schedule-button") Edit schedule
</template>

<script>
export default {
  name: 'CancelSaveEdit',
  props: {
    isSaving: Boolean,
    canEditSchedule: Boolean,
    index: Number,
  },
  computed: {
    dataTestId() {
      if (!this.index) return 'submit-button'
      return `submit-button-${this.index}`
    },
  },
}
</script>

<style scoped lang="stylus">
.briq-button
  margin-left 10px
</style>
